import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=2a23e6e4"
import script from "./HomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports